'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';
import { Breadcrumbs, Header, SponsoredBannersProvider } from '@/components';
import CouponsDealsSection from '@/components/sections/CouponsDealsSection';
import type { Store } from '@/lib/types/stores';

const API_BASE = process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:4000';

export default function CouponsPage() {
  const [stores, setStores] = useState<Store[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/stores`, { cache: 'no-store' });
        if (res.ok) {
          const data = await res.json();
          if (data?.stores) setStores(data.stores);
        }
      } catch {
        // ignore
      }
    })();
  }, []);

  return (
    <SponsoredBannersProvider>
      <div className="min-h-screen">
        <Header stores={stores} base={API_BASE} />

        <main className="home-page space-y-8 px-4 pb-16 sm:space-y-10 sm:px-8">
          <section className="relative mt-4 overflow-hidden sm:mt-6" aria-labelledby="coupons-hero-heading">
            <div className="mx-auto w-full">
              <div className="relative w-full overflow-hidden rounded-2xl bg-brand-100 sm:rounded-2xl">
                <div className="pointer-events-none absolute inset-0 z-0">
                  <Image
                    src="/media/pages/hero-bg-image.webp"
                    alt=""
                    fill
                    priority
                    className="object-cover object-center opacity-[0.05]"
                    sizes="100vw"
                    aria-hidden
                  />
                </div>
                <div className="pointer-events-none absolute inset-0 z-[1] bg-brand-100/10" aria-hidden />

                <div className="relative z-[2] flex flex-col gap-6 p-4 sm:gap-8 sm:p-6 lg:p-8">
                  <div className="min-w-0 max-w-2xl flex-1">
                    <Breadcrumbs items={[{ label: 'Coupons' }]} tone="onDark" />

                    <h1
                      id="coupons-hero-heading"
                      className="text-h2-mobile font-bold leading-tight text-white lg:text-h2-desktop"
                    >
                      Exclusive Deals & Drops
                    </h1>

                    <p className="mt-4 text-body-16-desktop font-normal leading-relaxed text-white/90">
                      Get the best bang for your bud. Browse our current offers, limited-time discounts, and
                      member-only coupons. Save on your favorite flower, vapes, and edibles today.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <CouponsDealsSection />
        </main>
      </div>
    </SponsoredBannersProvider>
  );
}
